export default __webpack_public_path__ + "i18n/de.c2b9a00e9879f0a5cd3018afe28df17b.json";